import { motion } from 'motion/react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionHomeHeaderRightImageProps {
  src: string;
  alt: string;
  className?: string;
  draggable?: boolean;
}

export const MotionHomeHeaderRightImage = ({
  src,
  alt,
  className,
  draggable,
  ...props
}: MotionHomeHeaderRightImageProps) => {
  return (
    <MotionHomeHeaderRightImageWrapper
      src={src}
      alt={alt}
      {...props}
      className={className}
      draggable={draggable}
      initial={{
        opacity: 0,
        y: ANIMATION_CONFIG.homeHeader.rightImage.yOffset,
        x: ANIMATION_CONFIG.homeHeader.rightImage.xOffset,
      }}
      animate={{ opacity: 1, y: 0, x: 0 }}
      transition={{
        duration: ANIMATION_CONFIG.homeHeader.rightImage.duration,
        delay: ANIMATION_CONFIG.homeHeader.rightImage.delay,
        ease: 'easeIn',
        type: 'spring',
      }}
    />
  );
};

const MotionHomeHeaderRightImageWrapper = styled(motion.img)``;
